import { Component, Input, OnInit } from '@angular/core';
import { ConfigLandignPage } from 'src/app/shared/models/ConfigLandingPage';
import { Utils } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {
  @Input() companies;
  @Input() configLandingPage: ConfigLandignPage;
  url = environment.filesUrl;
  @Input() lang: string;

  constructor() { }

  ngOnInit(): void {
  }

  getValueTranslate(columnName: string) {
    return Utils.getValueTranslate(this.lang, this.configLandingPage, columnName);
  }

}
